import { render, staticRenderFns } from "./ShowPage.vue?vue&type=template&id=1ec0fc72&"
import script from "./ShowPage.vue?vue&type=script&lang=js&"
export * from "./ShowPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports